import * as subject from '../enums/subjects'

/**
 * resolves a subject to its translated version
 */
let resolve = (id, subjects) => {
  switch (id) {
    case subject.MATHEMATICS_ID:
      return subjects.mathematics
    case subject.ENGLISH_LANGUAGE_ARTS_ID:
      return subjects.englishLanguageArts
    case subject.SCIENCE_ID:
      return subjects.science
    case subject.SOCIAL_STUDIES_ID:
      return subjects.socialStudies
    case subject.ART_AND_DESIGN_ID:
      return subjects.artAndDesign
    case subject.ENGLISH_AS_A_SECOND_LANGUAGE_ID:
      return subjects.englishAsASecondLanguage
    case subject.FOREIGN_LANGUAGES_ID:
      return subjects.foreignLanguages
    case subject.GEOGRAPHY_ID:
      return subjects.geography
    case subject.HEALTH_AND_PHYSICAL_EDUCATION_ID:
      return subjects.healthAndPhysicalEducation
    case subject.HISTORY_ID:
      return subjects.history
    case subject.RELIGION_ID:
      return subjects.religion
    case subject.CITIZENSHIP_ID:
      return subjects.citizenship
    case subject.ICT_ID:
      return subjects.ict
    case subject.MUSIC_ID:
      return subjects.music
    case subject.SPECIAL_EDUCATION_ID:
      return subjects.specialEducation
    case subject.OTHER_ID:
      return subjects.other
    case subject.MODERN_FOREIGN_LANGUAGES_ID:
      return subjects.modernForeignLanguages
    case subject.CROSS_CURRICULAR_ID:
      return subjects.crossCurricular
  }
}

let resolveToMasterSubjectList = (id, subjects) => {
  switch (id) {
    case subject.ART_AND_DESIGN_ID:
    case subject.MUSIC_ID:
      return subjects.artsEducation
    case subject.SOCIAL_STUDIES_ID:
    case subject.GEOGRAPHY_ID:
    case subject.HISTORY_ID:
    case subject.CITIZENSHIP_ID:
      return subjects.socialStudies
    case subject.SPECIAL_EDUCATION_ID:
    case subject.OTHER_ID:
    case subject.CROSS_CURRICULAR_ID:
      return subjects.careerTechnicalEducation
    case subject.HEALTH_AND_PHYSICAL_EDUCATION_ID:
      return subjects.healthAndPE
    case subject.ENGLISH_LANGUAGE_ARTS_ID:
      return subjects.languageArts
    case subject.MATHEMATICS_ID:
      return subjects.mathematics
    case subject.SCIENCE_ID:
      return subjects.science
    case subject.ICT_ID:
      return subjects.technologyEducation
    case subject.ENGLISH_AS_A_SECOND_LANGUAGE_ID:
    case subject.FOREIGN_LANGUAGES_ID:
    case subject.MODERN_FOREIGN_LANGUAGES_ID:
    case subject.RELIGION_ID:
      return subjects.worldLanguages
    case subject.LIBRARY_MEDIA_ID:
      return subjects.libraryMedia
  }
}

export default {
  resolve,
  resolveToMasterSubjectList
}
